import * as React from 'react';
import { MergeStylesDefaultContext } from '../contexts/MergeStylesDefaultContext';
/**
 * Get the map of stylesheets available in the context.
 */
export var useMergeStylesRootStylesheets = function () {
    return React.useContext(MergeStylesDefaultContext).stylesheets;
};
//# sourceMappingURL=useMergeStylesRootStylesheets.js.map